import React, { useMemo } from 'react';
import { AppointmentDetailsTab } from './Details/AppointmentDetailsTab';
import { AppointmentDocumentsTab } from './Documents/AppointmentDocumentsTab';
import { TabListTW } from '../../../../../tailwindComponents/tabTW/TabTW';
import { UUID } from 'types/shared/UUID';
import { ISigningAppointmentResponse } from 'types/signingAppointment/ISigningAppointmentResponse';
import { useSelectAppointmentFromPathParam } from 'utilities/order/scheduling/useSomeAppointmentFromParam';
import { shouldHideTabForDigitalSchedulingSigSyncAppointment } from './Documents/Utils';

export const AppointmentTabsContainer: React.FC<{
  onAddEventClick: (appointmentId?: UUID) => void;
}> = ({ onAddEventClick }) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  const shouldHideDocumentsTab = shouldHideTabForDigitalSchedulingSigSyncAppointment(
    appointmentFromPath as ISigningAppointmentResponse
  );

  const appointmentTabContent = useMemo(
    () => ({
      Details: <AppointmentDetailsTab onAddEventClick={onAddEventClick} />,
      ...(shouldHideDocumentsTab ? {} : { Documents: <AppointmentDocumentsTab /> }),
    }),
    [onAddEventClick, shouldHideDocumentsTab]
  );

  const tabTitles = useMemo(
    () => ['Details', ...(shouldHideDocumentsTab ? [] : ['Documents'])],
    [shouldHideDocumentsTab]
  );

  return (
    <TabListTW
      key={appointmentFromPath?.id}
      tabTitles={tabTitles}
      tabContent={appointmentTabContent}
      defaultTab={'Details'}
    />
  );
};
